import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const SurveyTemplatesProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `Survey/${props.id}`, method: 'GET', secure: true });
    }, [execute]);

    const newRecord = useCallback(async () => {
        await execute({ scope: 'new', url: 'Survey/', method: 'GET', secure: true  });
    }, [execute]);

    const createRecord = useCallback(async (props) => {
        await execute({ scope: 'create', url: 'Survey', method: 'POST', payload: props, secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'update', url: 'Survey', method: 'POST', payload: props, secure: true });
    }, [execute]);
    
    const listRecords = useCallback(async () => {
        await execute({ scope: 'list', url: 'Survey/GetSurveyMasterTemplates', method: 'GET', secure: true });
    }, [execute]);   

    const deleteRecord = useCallback(async (id) => {
        await execute({ scope: 'delete', url: `Survey/${id}`, method: 'DELETE', secure: true });
    }, [execute]);

    const value = { selectRecord, listRecords, newRecord, deleteRecord, updateRecord, createRecord, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useSurveyTemplatesStore = () => React.useContext(Context);
